<script setup lang="ts">
const props = defineProps<{
  block: BlockMediaArray,
  noHorizontalPadding?: boolean,
}>()

// hasMany uploads are typed as (string | Media)[] because Payload can return
// unpopulated ids — the GraphQL fragment always selects the full object.
const media = computed(() => (props.block.media ?? []).filter(item => typeof item !== 'string') as Media[])
</script>

<template>
  <section class="container-xl my-3" :class="{ 'px-1': !noHorizontalPadding }">
    <h2 v-if="block.label" class="label">
      {{ block.label }}
    </h2>

    <core-media-preview
      :media="media"
      :limit="8"
    />
  </section>
</template>
